import { Component, type ReactNode } from "react";

type FilterSquareProps = {
  title: String;
  onClick: () => void;
  children?: ReactNode;
};

export class FilterSquare extends Component<FilterSquareProps, {}> {
  render(): ReactNode {
    return (
      <div
        className="flex items-center rounded py-2 px-2 bg-white cursor-pointer border border-[rgba(0,0,0,0)] hover:border-primary"
        onClick={this.props.onClick}
      >
        <div className="mr-1 sm:mr-2">{this.props.children}</div>
        {/*<div className="text-sm">*/}
        {/*    {this.props.title}*/}
        {/*</div>*/}
        {this.props.title && <div className="text-xs">{this.props.title}</div>}
      </div>
    );
  }
}
